"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEX_REPLACE = void 0;
exports.REGEX_REPLACE = {
    alias: 'SUBSTITUIR_REGEX',
    description: 'Utiliza {regex} para buscar na {string_original} e substituir por {substituir_por}',
    arg_names: ['string_original', 'regex', 'substituir_por'],
    args_description: [
        'string a ser buscada e substituída',
        'regex para buscar',
        'string a substituir',
    ],
};
